const ComingSoonButton = () => {
    return (
        <button
            disabled={true}
            className={`
inline-flex
items-center
px-4
py-4
mt-4
text-lg
font-bold
transition-all
duration-200
bg-transparent
border border-transparent
sm:mt-0
font-pj
justify-center
rounded-xl
focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300
hover:bg-gray-200
focus:bg-gray-200
`}
            role='button'>
            Coming Soon
        </button>
    );
};

export default ComingSoonButton;
